export function items(state, response) {
  state.items = response
}
export function pagination(state, response) {
  state.pagination = response
}

export function item(state, response) {
  state.item = response
}

export function car(state, response) {
  state.car = response
}
